"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createScfUiSchema = void 0;
var tables_1 = require("../../tables/tables");
var Utils_1 = require("../../Utils");
var AutoModuleHelpers_1 = require("../AutoModuleHelpers");
var ContextualHelp_1 = require("../ContextualHelp");
function createScfUiSchema(tab, config, model) {
    var _a;
    var scfUiSchema = {};
    if (config) {
        var components = getAllComponents(model);
        (_a = (0, Utils_1.values)(components)) === null || _a === void 0 ? void 0 : _a.forEach(function (entry) {
            var _a, _b, _c, _d;
            var component = entry.component;
            var name = component.name, group = component.group;
            var schema = {};
            if (component.tabs.indexOf(tab) == -1)
                return;
            if (!scfUiSchema[group]) {
                scfUiSchema[group] = {};
            }
            if (!scfUiSchema[group][name]) {
                scfUiSchema[group][name] = {};
            }
            var actions = getActions(component, model);
            var transformErrors = model.getDerivedFunction("getCustomUiErrors", name);
            if (model.getImports()) {
                var deviceMeta = model.getImportValue("device_meta");
                var hasSdlSupport = (_a = deviceMeta === null || deviceMeta === void 0 ? void 0 : deviceMeta.hasSdlSupport) !== null && _a !== void 0 ? _a : false;
                if (component.sdlHelp && hasSdlSupport) {
                    var helpUrl = component.sdlHelp.url;
                    schema["helpKeyword"] = getHelpKeyword(model, name, helpUrl);
                    schema["tooltip"] = getTooltip(component);
                }
            }
            if (component.category === "table") {
                var tableState = (_d = (_c = (_b = model === null || model === void 0 ? void 0 : model.getState()) === null || _b === void 0 ? void 0 : _b[tab]) === null || _c === void 0 ? void 0 : _c[group]) === null || _d === void 0 ? void 0 : _d[name];
                var uids = (0, tables_1.createTableUids)(component, tab, model, tableState);
                schema["table"] = getTableUiSchema(component, uids);
                actions = (0, tables_1.getTableActions)(component, tab, model, uids);
            }
            schema["precision"] = component["precision"];
            schema["shouldDispatchOnChange"] = component["shouldDispatchOnChange"];
            if (actions) {
                schema["actions"] = actions;
            }
            if (transformErrors) {
                schema["transformErrors"] = transformErrors;
            }
            scfUiSchema[group][name] = __assign({}, schema);
        });
    }
    return scfUiSchema;
}
exports.createScfUiSchema = createScfUiSchema;
function getAllComponents(model) {
    return model.getAutoModuleAppModel().getAllComponents();
}
function getHelpKeyword(model, componentName, helpUrl) {
    var _a;
    return ((_a = model.getDerivedFunction("getHelpUrl", componentName, helpUrl)) !== null && _a !== void 0 ? _a : (0, ContextualHelp_1.getAutoSdlHelp)(model, componentName, helpUrl));
}
function getTooltip(component) {
    var _a, _b;
    return (_b = (_a = component.sdlHelp) === null || _a === void 0 ? void 0 : _a.tooltip) !== null && _b !== void 0 ? _b : "Click for more information";
}
function getTableUiSchema(component, uids) {
    var cellValidationInfo = (0, tables_1.getCellValidationInfo)(component);
    return {
        canRemoveRows: component.canRemoveRows,
        canInsertRows: component.canInsertRows,
        canAddRows: component.canAddRows,
        canMoveRowDown: component.canMoveRowDown,
        canMoveRowUp: component.canMoveRowUp,
        canEnableRows: component.canEnableRows,
        uids: uids,
        cellValidationInfo: cellValidationInfo,
    };
}
function getDependencySelectorActions(component, model) {
    var depSelector = new AutoModuleHelpers_1.DependencySelector(model, component);
    var options = depSelector.generateDropdownOptions();
    var dependencySelectorActions = [];
    options.forEach(function (dropdownOption) {
        var option = dropdownOption.value;
        dependencySelectorActions.push({
            type: "[Import] SET",
            payload: {
                importId: component.importId,
                handle: option === null || option === void 0 ? void 0 : option.handle,
                interfaceId: option === null || option === void 0 ? void 0 : option.interfaceId,
                option: dropdownOption.label,
            },
        });
    });
    return JSON.stringify(dependencySelectorActions);
}
function getActions(component, model) {
    if (component.category === "import") {
        return getDependencySelectorActions(component, model);
    }
    var actions = model.getDerivedFunction("getActions", component.name, component.actions);
    return JSON.stringify(actions); //TODO: support map
}
//# sourceMappingURL=scfUiSchema.js.map